import { select } from 'd3-selection'
class UnseatZone {
  constructor(props) {
    this.unseatZoneContainer = props.unseatZoneContainer
    this.overUnseatZone = false
    this.draw()
  }

  draw = () => {
    this.node = select(this.unseatZoneContainer)
      .append('div')
      .style('position', 'absolute')
      .style('border-radius', '4px')
      .style('border', 'solid #FFF 8px')
      .style('bottom', '40px')
      .style('right', '170px')
      .style('display', 'flex')
      .style('align-items', 'center')
      .style('transform', 'scale(0)')
      .style('width', '110px')
      .style('height', '56px')
      .style('background-color', 'var(--boulevardier)')
      .style('box-shadow', 'var(--blue-shadow)')
      .style('border-radius', '14px')
      .style('z-index', 10)
      .on('dragover', () => {
        if (this.dragging) {
          this.overUnseatZone = true
          this.node.transition().duration(100).style('transform', 'scale(1.1)')
        }
      })
      .on('mouseover', () => {
        if (this.dragging) {
          this.overUnseatZone = true
          this.node.transition().duration(100).style('transform', 'scale(1.1)')
        }
      })
      .on('mouseout', () => {
        if (this.dragging) {
          this.overUnseatZone = false
          this.node.transition().duration(100).style('transform', 'scale(1)')
        }
      })
    this.node
      .append('i')
      .attr('class', 'fa-solid fa-user-minus ')
      .style('padding-left', '8px')
      .style('font-size', '15px')
      .style('color', '#FEFEFE')

    this.node
      .append('span')
      .text('Unassign')
      .style('padding-left', '8px')
      .style('font-size', '12px')
      .style('font-weight', '700')
      .style('color', '#FEFEFE')
  }

  show = () => {
    this.dragging = true
    this.overUnseatZone = false
    this.node.transition().duration(100).style('transform', 'scale(1)')
  }

  hide = () => {
    this.dragging = false
    this.overUnseatZone = false
    this.node.transition && this.node.transition().duration(100).style('transform', 'scale(0)')
  }

  visible = () => this.dragging

  isOver = () => this.overUnseatZone
}

export default UnseatZone
